module.exports = __webpack_public_path__ + "static/img/import-data.e49cabb1.png";